import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PrintIcon from '@mui/icons-material/Print';
import { Box, Button, Typography } from '@mui/material';
import { FC, memo, useCallback, useContext, useState } from 'react';
import { useLocation } from 'react-router';
import PickingListComponent from 'src/components/PickingListComponent';
import LicenseContext from 'src/contexts/LicenseContext';

import PickingListPresenter from './PickingListPresenter';

const PickingList: FC = memo(() => {
  const licenseContext = useContext(LicenseContext);
  const query = new URLSearchParams(useLocation().search);
  const shiftIds = query.get('ids').split(',').map((id) => Number(id));
  const date = query.get('date');
  const selectedShippers = query.getAll('shipper_names[]');
  const barcodeShippers = query.getAll('barcode_shipper_names[]');

  const [pageCount, setPageCount] = useState(0);
  const handleCountChange = useCallback((count: number) => setPageCount(count), []);

  return (
    <>
      {/* ツールバー - 印刷時は非表示 */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 3,
        py: 1.5,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        '@media print': { display: 'none' },
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Button variant="outlined" startIcon={<ArrowBackIcon />} size="small" onClick={() => window.close()}>
            戻る
          </Button>
          {pageCount > 0 && (
            <Typography variant="body2" color="text.secondary">
              {pageCount}件のピッキングリスト
            </Typography>
          )}
        </Box>
        <Button variant="contained" startIcon={<PrintIcon />} size="small" onClick={() => window.print()}>
          印刷
        </Button>
      </Box>
      {/* プレビューエリア */}
      <Box sx={{
        minHeight: '100vh',
        backgroundColor: 'grey.200',
        pt: 8,
        pb: 2,
        '@media print': { backgroundColor: 'white', p: 0, minHeight: 0 },
      }}>
        <PickingListComponent
          shiftIds={shiftIds}
          date={date}
          presenter={PickingListPresenter}
          unit={licenseContext.config?.unit}
          onCountChange={handleCountChange}
          initialSelectedShippers={selectedShippers}
          initialBarcodeShippers={barcodeShippers}
        />
      </Box>
    </>
  );
});

export default PickingList;
